/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum FreightClaimState {
  Created = "created",
  WaitingForCarrier = "waiting_for_carrier",
  WaitingForCustomer = "waiting_for_customer",
  WaitingForInsurance = "waiting_for_insurance",
  AcceptedWaitingForPayment = "accepted_waiting_for_payment",
  AcceptedPaymentSentToCustomer = "accepted_payment_sent_to_customer",
  RejectedByCarrier = "rejected_by_carrier",
  Cancelled = "cancelled",
}

export function instanceOfFreightClaimState(value: any): boolean {
  for (const key in FreightClaimState) {
    if (Object.prototype.hasOwnProperty.call(FreightClaimState, key)) {
      if (FreightClaimState[key as keyof typeof FreightClaimState] === value) {
        return true;
      }
    }
  }
  return false;
}

export function FreightClaimStateFromJSON(json: any): FreightClaimState {
  return FreightClaimStateFromJSONTyped(json, false);
}

export function FreightClaimStateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): FreightClaimState {
  return json as FreightClaimState;
}

export function FreightClaimStateToJSON(value?: FreightClaimState | null): any {
  return value as any;
}

export function FreightClaimStateToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): FreightClaimState {
  return value as FreightClaimState;
}
